<template>
  <div
    class="rs-image-header"
    :style="style"
  >
    <div
      v-if="isUpdatePermitted"
      class="rs-image-header__top"
    >
      <RsButton
        v-if="!isBtnInputForm && isUpdatePermitted"
        class="img-floating-btn"
        variant="light"
        icon="pencil"
        @click="$emit('clicked')"
      />
      <RsFormFile
        v-else
        :id="`post-file-upload-${id}`"
        class="img-floating-btn"
        variant="pencil"
        accept="image/jpeg,image/png,image/gif,image/webp"
        @on-upload-triggered="$emit('on-upload-triggered', $event)"
      />

      <RsButton
        v-if="!!image && isRemoveable"
        class="img-floating-btn mt-2 trash-icon"
        variant="error"
        icon="trash-alt"
        @click="$emit('removeImg')"
      />
    </div>
    <div class="rs-image-header__bottom">
      <RsPropertyTitle
        v-if="title"
        :text="title"
      />
      <RsPropertyLocation
        v-if="location"
        :text="location"
      />
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsImageHeader',
  props: {
    id: {
      type: String,
      default: 'rs-image-header',
    },
    title: String,
    location: String,
    image: String,
    isBtnInputForm: {
      type: Boolean,
      default: false,
    },
    isUploading: {
      type: Boolean,
      default: false,
    },
    isRemoveable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style(): string {
      return `background-image:url(${
        this.image || '/img/default_960x540.png'
      })`;
    },
  },
});
</script>

<style lang="scss">
@import "@/styles/_variables.scss";
.rs-image-header {
  position: relative;
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  padding: 1rem;
  width: 100%;
  height: 228px;
  overflow: hidden;
  border-radius: $global-radius;
  background-position: center;
  background-size: cover;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba(34, 26, 64, 0),
      rgba(34, 26, 64, 1)
    );
  }

  &__top {
    width: 100%;
  }
  &__bottom {
    position: absolute;
    bottom: 0;
    padding: 1rem 0;
    color: $white;
    .rs-prop-title {
      color: $white;
      font-size: 1.5rem;
    }
    .rs-prop-location {
      color: $white;
      .rs-icon {
        color: $secondary-color;
      }
    }
    p {
      margin: 0;
      color: $white;
      font-weight: 600;
    }
  }
  .img-floating-btn {
    display: flex;
    opacity: 0.8;
    width: 40px;
    height: 40px;
    margin-left: auto;
  }
  .trash-icon {
    margin-top: 120px !important;
  }
}
</style>
